import React from 'react';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import AmenityList from 'components/common/amenity-list';

export default function LocationFeatures({ amenities }) {
  if (!amenities) { return null; }

  const bsClasses = cx({
    'col-xs-10': true,
    'col-xs-offset-1': true,
    'col-md-12': true,
    'col-md-offset-0': true,
    'padding-0': true,
    'area': true,
    'amenity-list': true,
  });

  return (
    <div className="row hidden-print">
      <h6 className={`h6-sg text-color-dark-slate text-weight-medium ${bsClasses}`}>
        <FormattedMessage id="parking-pass.location-features" defaultMessage="LOCATION FEATURES" />
      </h6>
      <AmenityList
        amenities={amenities}
        className={bsClasses}
        amenityClassName="col-xs-4 col-md-2 margin-bottom-20"
      />
    </div>
  );
}
